<template>
  <Modal @close="close">
    <div slot="modal-header" v-html="systemTitle"></div>

    <div class="d-flex flex-column justify-content-center align-items-center">
      <label class="text-center">
        <b>{{ $t('general.color') }} (RAL)</b>
        <el-select v-model="color" class="d-block" filterable>
          <el-option v-for="ral in RALCOLORS" :key="ral.code" :value="ral.code" :label="`${ral.name} (${ral.code})`">
            <div class="d-flex justify-content-between align-items-center">
              <div class="color-square" :style="{ background: ral.hex }" />
              <span>{{ `${ral.name} (${ral.code})` }}</span>
            </div>
          </el-option>
        </el-select>
      </label>
      <label class="text-center">
        <b>{{ $t('general.area') }}(qm)</b>
        <el-input v-model.number="area" class="d-block" />
      </label>
    </div>
    <div slot="modal-footer">
      <el-button @click="addTo">
        {{ $t('general.add') }}
      </el-button>
    </div>
  </Modal>
</template>

<script>
import Modal from '../atoms/Modal';
import { mapActions, mapGetters } from 'vuex';
import StoreModules from '../../store/store-modules';
import RALCOLORS from '../../js/constants/ral-colors';
export default {
  name: 'AddSystemModal',
  components: { Modal },
  props: {
    system: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {},
  destroyed() {},
  data() {
    return {
      RALCOLORS,
      color: '',
      area: 0.0,
    };
  },
  computed: {
    systemTitle() {
      return this.system.get('name') + this.$t('general.add_to_cart');
    },
  },
  methods: {
    ...mapActions(StoreModules.CART, ['addToCart']),
    close() {
      this.$emit('close');
    },
    addTo() {
      if (this.color === '') {
        this.$message.error(this.$t('errors.enter_color_msg'));
        return;
      }
      if (this.area <= 0) {
        this.$message.error(this.$t('errors.enter_area_msg'));
        return;
      }
      let item = {
        modxId: this.system.get('modxId'),
        objectId: this.system.id,
        name: this.system.get('name'),
        area: this.area,
        color: this.color,
      };

      this.addToCart({ type: 'systems', items: [item] }).then(() => {
        this.close();
        this.$message.info(this.$t('messages.added_item_success'));
      });
    },
  },
};
</script>

<style scoped>
.color-square {
  width: 15px;
  height: 15px;
  margin-right: 15px;
  border: 1px solid #929292;
}
</style>
